<pxc-form
  class="h-[75vh]"
  [form]="form"
  [formAnswer]="formAnswer"
  [formInputs]="formInputs"
  [readOnly]="readOnly"
  (completed)="complete($event)" />
